import { render } from "./BookingDetailsPage.vue?vue&type=template&id=033ca1d2&scoped=true"
import script from "./BookingDetailsPage.vue?vue&type=script&lang=js"
export * from "./BookingDetailsPage.vue?vue&type=script&lang=js"

import "./BookingDetailsPage.vue?vue&type=style&index=0&id=033ca1d2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033ca1d2"]])

export default __exports__